import { StyleSheet } from 'react-native';
import { EDColors } from '../../constants/Colors';
import { Units } from '../../constants/Unit';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: EDColors.topbar,
    },
    scrollView: {
        backgroundColor: "#E5E5E5",
        flexGrow: 1
    },
    title: {
        color: "#010A41",
        fontFamily: Units.ftFamily.MontserratB,
        fontSize: 36,
        marginTop: 50,
        marginLeft: 50
    },
    subtitle: {
        color: "#4d577b",
        fontFamily: Units.ftFamily.MontserratR,
        fontSize: 16,
        marginTop: 8,
        marginLeft: 50
    },
    row: {
        flexDirection: "row",
        flexWrap: "wrap",
        marginHorizontal: 35,
    },
    card: {
        backgroundColor: "#fff",
        borderRadius: 15,
        padding: 25,
        marginHorizontal: 15,
        marginTop: 25,
        marginLeft: 50,
        marginRight: 50,
    },
    formCard: {
        flex: 2,
        minWidth: 360,
        marginLeft: 15,
        marginRight: 15,
    },
    previewWrapper: {
        flex: 1,
        minWidth: 300,
        marginLeft: 15,
        marginRight: 15,
    },
    dangerCard: {
        borderWidth: 1,
        borderColor: "#f3c4c4",
    },
    label: {
        color: "#010A41",
        fontFamily: Units.ftFamily.MontserratB,
        fontSize: 14,
        marginBottom: 8,
    },
    input: {
        backgroundColor: "#f5fafd",
        borderWidth: 1,
        borderColor: EDColors.itembdr,
        borderRadius: 10,
        padding: 12,
        fontSize: 15,
        fontFamily: Units.ftFamily.KarlaR,
    },
    textArea: {
        height: 120,
        textAlignVertical: "top",
    },
    emailInput: {
        width: 320,
        marginRight: 15,
    },
    counter: {
        alignSelf: "flex-end",
        color: EDColors.grey,
        fontSize: 12,
        marginTop: 4,
        marginBottom: 15,
    },
    titleRow: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
    },
    consoleButton: {
        marginTop: 60,
        marginRight: 50,
    },
    hint: {
        color: "#4d577b",
        fontSize: 13,
        marginTop: 4,
    },
    stepTitle: {
        color: "#010A41",
        fontFamily: Units.ftFamily.MontserratB,
        fontSize: 18,
    },
    inlineRow: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 15,
    },
    warningTxt: {
        color: "#b26a00",
        fontSize: 13,
        marginTop: 10,
    },
    result: {
        fontSize: 13,
        marginTop: 12,
    },
    resultSuccess: {
        color: EDColors.green,
    },
    resultError: {
        color: EDColors.red,
    },
    button: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        height: 42,
        paddingHorizontal: 20,
        borderRadius: 21,
        backgroundColor: EDColors.primary,
    },
    buttonDanger: {
        backgroundColor: EDColors.red,
    },
    buttonSecondary: {
        backgroundColor: "#fff",
        borderWidth: 1,
        borderColor: EDColors.topbar,
    },
    buttonDisabled: {
        opacity: 0.4,
    },
    buttonTxt: {
        color: "#fff",
        fontFamily: Units.ftFamily.MontserratB,
        fontSize: 14,
    },
    buttonTxtSecondary: {
        color: EDColors.topbar,
    },
    previewCard: {
        backgroundColor: "#f2f3f5",
        borderRadius: 16,
        padding: 14,
    },
    previewHeader: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 6,
    },
    previewAppIcon: {
        width: 18,
        height: 18,
        borderRadius: 4,
        backgroundColor: EDColors.topbar,
        marginRight: 6,
    },
    previewAppName: {
        flex: 1,
        color: "#4d577b",
        fontSize: 11,
        letterSpacing: 0.5,
    },
    previewTime: {
        color: "#4d577b",
        fontSize: 11,
    },
    previewTitle: {
        color: "#000",
        fontWeight: "bold",
        fontSize: 15,
    },
    previewBody: {
        color: "#222",
        fontSize: 14,
        marginTop: 2,
    },
    previewLinkRow: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 8,
    },
    previewLink: {
        color: EDColors.topbar,
        fontSize: 13,
        flexShrink: 1,
    },
    inputError: {
        borderColor: EDColors.red,
    },
    errorTxt: {
        color: EDColors.red,
        fontSize: 13,
        marginTop: 4,
    },
    historyLink: {
        color: EDColors.topbar,
        fontSize: 12,
        marginTop: 2,
    },
    historyHeader: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 10,
    },
    historyItem: {
        flexDirection: "row",
        paddingVertical: 12,
        borderTopWidth: 1,
        borderTopColor: "#eee",
    },
    historyTitle: {
        color: "#010A41",
        fontFamily: Units.ftFamily.MontserratB,
        fontSize: 14,
    },
    historyBody: {
        color: "#222",
        fontSize: 13,
        marginTop: 2,
    },
    historyMeta: {
        alignItems: "flex-end",
        marginLeft: 20,
    },
    historyMetaTxt: {
        color: EDColors.grey,
        fontSize: 12,
    },
    status: {
        fontSize: 12,
        fontWeight: "bold",
        textTransform: "uppercase",
    },
    modalBg: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, .5)",
        justifyContent: "center",
        alignItems: "center",
    },
    modal: {
        width: 460,
        maxWidth: "90%",
        backgroundColor: "#fff",
        borderRadius: 15,
        padding: 25,
    },
    modalWarning: {
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: EDColors.bgred,
        borderRadius: 10,
        padding: 12,
        marginBottom: 20,
    },
    modalWarningTxt: {
        flex: 1,
        color: EDColors.red,
        fontFamily: Units.ftFamily.MontserratB,
        fontSize: 14,
        marginLeft: 10,
    },
    modalButtons: {
        flexDirection: "row",
        justifyContent: "flex-end",
        marginTop: 25,
    },
});

export default styles;
